import { NgModule } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from './loading/loading.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CustomContextMenuDirective } from 'src/app/common/directives/custom-context-menu.directive';
import { CustomProgressbarDirective } from 'src/app/common/directives/custom-progressbar.directive';
import { ErrorGridDialogComponent } from './dialogs/error-grid-dialog/error-grid-dialog.component';
import { DopTableModule } from 'projects/dop-table/src/public_api';
import { CommonModule } from '@angular/common';
import { ErrorGridDialogMessageService } from './dialogs/error-grid-dialog/error-grid-dialog.message.service';
import { ProgressBarModule } from 'primeng/progressbar';
import { OverlayComponent } from './overlay/overlay.component';

@NgModule({
    declarations: [
        LoadingComponent,
        CustomContextMenuDirective,
        CustomProgressbarDirective,
        OverlayComponent,
        ErrorGridDialogComponent
    ],
    imports: [
        HttpClientModule,
        FormsModule,
        StepsModule,
        BreadcrumbModule,
        MenubarModule,
        SplitButtonModule,
        ProgressSpinnerModule,
        ProgressBarModule,
        DopTableModule,
        CommonModule
    ],
    exports: [
        HttpClientModule,
        FormsModule,
        StepsModule,
        BreadcrumbModule,
        MenubarModule,
        SplitButtonModule,
        ProgressBarModule,
        LoadingComponent,
        CustomContextMenuDirective,
        CustomProgressbarDirective,
        ErrorGridDialogComponent,
        OverlayComponent
    ],
    providers: [ErrorGridDialogMessageService]
})
export class SharedModule { }
